"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstTile = exports.getRandomFloor = exports.convertJtoY = exports.convertItoX = exports.convertIIJtoXY = exports.convertIJtoXY = exports.convertSXtoI = exports.convertSYtoJ = exports.convertYtoJ = exports.convertXtoI = exports.getIJAtMouse = exports.update = exports.getSafeOffset = exports.getSafeXY = exports.getSafeIIJ = exports.getSafe = exports.getUnsafe = exports.inRange = exports.clear = exports.create = exports.getSize = exports.getAllTiles = exports.getNumTiles = exports.get = exports.spotSize = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveTilemap_generic_sidecar_1 = require("./diveTilemap_generic-sidecar");
exports.spotSize = 10 * 4; // * 0.99 // Do we need a small overlap to fix render gaps?
var _obj = null;
function get() {
    assert_sidecar_1.assert.notNil(_obj, 'tilemap not created');
    return _obj;
}
exports.get = get;
function getNumTiles() {
    return get().parts.length;
}
exports.getNumTiles = getNumTiles;
function getAllTiles() {
    return get().parts;
}
exports.getAllTiles = getAllTiles;
function getSize() {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getSize(get());
}
exports.getSize = getSize;
function create() {
    _obj = diveTilemap_generic_sidecar_1.diveTilemap_generic.create(83, 83);
    return _obj;
}
exports.create = create;
function clear() {
    diveTilemap_generic_sidecar_1.diveTilemap_generic.clear(get());
}
exports.clear = clear;
function inRange(i, j) {
    var obj = get();
    return i >= 0 && i < obj.width && j >= 0 && j < obj.height;
}
exports.inRange = inRange;
function getUnsafe(i, j) {
    var obj = get();
    assert_sidecar_1.assert.t(inRange(i, j), 'not in range', i, j);
    return obj.parts[i + j * obj.width];
}
exports.getUnsafe = getUnsafe;
function getSafe(i, j) {
    var obj = get();
    if (!inRange(i, j)) {
        return null;
    }
    return obj.parts[i + j * obj.width];
}
exports.getSafe = getSafe;
function getSafeIIJ(iij) {
    return getSafe(iij.i, iij.j);
}
exports.getSafeIIJ = getSafeIIJ;
function getSafeXY(ixy) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getSafeXY(get(), ixy);
}
exports.getSafeXY = getSafeXY;
function getSafeOffset(iij, oi, oj) {
    return getSafe(iij.i + oi, iij.j + oj);
}
exports.getSafeOffset = getSafeOffset;
function update() { }
exports.update = update;
function getIJAtMouse() {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getIJAtMouse();
}
exports.getIJAtMouse = getIJAtMouse;
function convertXtoI(_x) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertXtoI(_x);
}
exports.convertXtoI = convertXtoI;
function convertYtoJ(_y) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertYtoJ(_y);
}
exports.convertYtoJ = convertYtoJ;
function convertSYtoJ(_y) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertSYtoJ(_y);
}
exports.convertSYtoJ = convertSYtoJ;
function convertSXtoI(_x) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertSXtoI(_x);
}
exports.convertSXtoI = convertSXtoI;
function convertIJtoXY(i, j) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertIJtoXY(i, j);
}
exports.convertIJtoXY = convertIJtoXY;
function convertIIJtoXY(l) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertIIJtoXY(l);
}
exports.convertIIJtoXY = convertIIJtoXY;
function convertItoX(i) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertItoX(i);
}
exports.convertItoX = convertItoX;
function convertJtoY(j) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.convertJtoY(j);
}
exports.convertJtoY = convertJtoY;
function getRandomFloor() {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.getRandomFloor(get());
}
exports.getRandomFloor = getRandomFloor;
function findFirstTile(filter) {
    return diveTilemap_generic_sidecar_1.diveTilemap_generic.findFirstTile(get(), filter);
}
exports.findFirstTile = findFirstTile;
// export function addGameElevator(c: IDiveTilemapPart) {
//   let obj = get()
//   assert.eq(
//     c.text3,
//     c.text3.toLowerCase(),
//     'elevators must be lowercase',
//     c.text3,
//   )
//   if (!obj.elevators[c.text3]) {
//     obj.elevators[c.text3] = []
//   }
//   obj.elevators[c.text3].push(c)
// }
// export function getElevators(tag: string) {
//   let obj = get()
//   let els = obj.elevators[tag]
//   assert.notNil(els, 'no elevator with tag', tag)
//   return els
// }
// export function addGameSystem(c: IDiveTilemapPart) {
//   let obj = get()
//   let key = c.text3
//   return addGameSystem2(c, key)
// }
// export function addGameSystem2(c: IDiveTilemapPart, key: string) {
//   let data = voyageSystemsData.findBy(c.tile3.type, key)
//   if (voyageWebsockets.getIsHost()) {
//     assert.eq(key, key.toLowerCase(), 'systems must be lowercase', key)
//     assert.notEmptyString(key, 'key is empty!')
//     if (data.allowMultiple) {
//       let origKey = key
//       while (checkForDuplicateKey(key)) {
//         key = origKey + rando.i(1000, 9999)
//       }
//       c.text3 = key
//     }
//     voyageMessageSystemCreate.sendMessageAndImmediatelyExecute({
//       i: c.i,
//       j: c.j,
//       key,
//       systemId: get().nextSystemId++,
//     })
//     // assert.nil(obj.systems[key], 'duplicate system', '' + key)
//     // if (obj.systems[key] != null) {
//     //   console.warn('duplicate system', key, obj.systems[key])
//     // }
//     // voyageSystems.init(c, key)
//     // obj.systems[key] = c
//   }
//   return data
// }
// function checkForDuplicateKey(key: string) {
//   let obj = get()
//   if (obj.systemsByKey[key] != null) {
//     return true
//   }
//   return false
// }
// export function networkAddSystem(msg: IMessageSystemCreate) {
//   let obj = get()
//   let t = getSafe(msg.i, msg.j)
//   assert.notNil(t)
//   let key = msg.key
//   let id = msg.systemId
//   if (obj.systemsByKey[key] != null) {
//     console.warn('duplicate system key', key, id, obj.systemsByKey[key])
//   }
//   if (obj.systemsById[id] != null) {
//     console.warn('duplicate system id', key, id, obj.systemsByKey[key])
//   }
//   voyageSystems.init(t, key, id)
//   obj.systemsByKey[key] = t
//   obj.systemsById[id] = t
//   obj.systems.push(t)
// }
// export function getSystemByKey(key: string) {
//   let obj = get()
//   let sys = obj.systemsByKey[key]
//   assert.notNil(sys, 'no system with key', key)
//   return sys
// }
// export function getSystemByKeySafe(key: string) {
//   let obj = get()
//   let sys = obj.systemsByKey[key]
//   return sys || null
// }
// export function getSystemById(id: number) {
//   let obj = get()
//   let sys = obj.systemsById[id]
//   assert.notNil(sys, 'no system with id', id)
//   return sys
// }
// export function getSystemByIdSafe(id: number) {
//   let obj = get()
//   let sys = obj.systemsById[id]
//   return sys || null
// }
// export function getRandomFreeSystem(startsWith: string) {
//   let tm = get()
//   let width = tm.width
//   let height = tm.height
//   let options: IDiveTilemapPart[] = []
//   for (let j = 0; j < height; j++) {
//     for (let i = 0; i < width; i++) {
//       let t = getUnsafe(i, j)
//       //if (t.tile3.type === EVoyageTile.System) {
//       // if (t.items.length === 0 && t.crew === null) {
//       // if (t.text3) {
//       //   console.log(t.text3)
//       // }
//       if (t.tile3.type === EDiveTile.System) {
//         if (t.text3.startsWith(startsWith)) {
//           // console.log('found', t.text3, t.items.length, '' + t.crew)
//           if (t.items.length === 0 && t.crew.length === 0) {
//             options.push(t)
//           }
//         }
//       }
//       // }
//       //}
//     }
//   }
//   if (options.length === 0) {
//     return null
//   }
//   return rando.sample(options)
// }
// export function resetSystems() {
//   let tm = get()
//   let width = tm.width
//   let height = tm.height
//   tm.nextSystemId = 100
//   tm.elevators = {}
//   tm.systemsByKey = {}
//   tm.systemsById = {}
//   tm.systems = []
//   for (let j = 0; j < height; j++) {
//     for (let i = 0; i < width; i++) {
//       let t = getUnsafe(i, j)
//       voyageTilemapPart.setSystemImage(t, null)
//     }
//   }
//   // tm.breaches = []
// }
